import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@spartalabs/pdc-core';
import { Unauthorized } from 'components';
import {
  getFirstAllowedPortalPath,
  hasAnyPortalPermission,
  hasAnyPermissionFrom,
  hasPortalPermission,
} from 'utils/hasPortalPermission';

type RequirePortalPermissionProps = {
  children: React.ReactNode;
  permission?: Permission;
  anyOf?: ReadonlyArray<Permission>;
  /** Quando true, redireciona para a primeira rota permitida em vez de Unauthorized. */
  redirect?: boolean;
};

export const RequirePortalPermission = ({
  children,
  permission,
  anyOf,
  redirect = false,
}: RequirePortalPermissionProps) => {
  const permissions = useAppSelector(
    state => state.authSlicer.user.permissions,
  );

  const allowed = permission
    ? hasPortalPermission(permissions, permission)
    : hasAnyPermissionFrom(permissions, anyOf ?? []);

  if (allowed) return <>{children}</>;

  if (redirect && hasAnyPortalPermission(permissions)) {
    const fallback = getFirstAllowedPortalPath(permissions) ?? '/sem-acesso';
    return <Navigate to={fallback} replace />;
  }

  return <Unauthorized />;
};
